// extracted by mini-css-extract-plugin
export var actionIcon = "_pj-0";